export default {
  currentUserInfo: {},
};
